import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class ModbusSlaveNode extends BaseNode {
    constructor() {
        super();
        this.name = 'On Modbus Receive';
        this.id = 'node_modbus_slave_register';
        this.linkedFeature = 'general';
        this.requirements = ['tios'];
        this.icon = 'VscDebugStart';

        const settings: Setting[] = [
            {
                id: 'REGISTER',
                name: 'Modbus Register',
                settingType: SettingType.OPTION,
                refId: 'modbus_table_item',
                required: true,
                default: '',
                options: [],
            },
        ];

        this.settings = this.settings.concat(settings);

        this.outputs = [
            {
                name: 'Write',
                portId: 'modbus_value',
                params: [
                    {
                        name: 'data',
                        dataType: TibboDataType.FLOAT,
                    },
                ],
            },
        ];
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            const project: ProjectConfiguration = this.project;
            const REGISTER = this.getSettingValue('REGISTER');
            if (REGISTER) {
                const registerFeature = project.getFeature(REGISTER);
                return `On Modbus Register {{$${registerFeature?.getSettingValue('NAME')}}} written`;
            }
        }
        return super.getSettingValue(settingId);
    }

    // validate(): Array<ValidationMessage> {
    //     const project: ProjectConfiguration = this.project;
    //     const OUTPUTS = this.getOutputs();
    //     const ID = this.getSettingValue('FEATURE');
    //     const register = project.getFeature(ID);
    //     const VARTYPE = register.getSettingValue('VARTYPE');
    //     const DATATYPE = register.getSettingValue('DATATYPE');
    //     let varName = '';
    //     let varType = TibboDataType.WORD;
    //     switch (DATATYPE) {
    //         case 'COIL': // coil
    //             varName = 'modbus_callback_ReadCoilStatus';
    //             varType = TibboDataType.BOOLEAN;
    //             break;
    //         case 'INPUT': // discrete contact/ cinput
    //             varName = 'modbus_callback_ReadInputStatus';
    //             varType = TibboDataType.BOOLEAN;
    //             break;
    //         case 'HREG': // holding register
    //             varName = 'modbus_callback_ReadHoldingRegister';
    //             varType = TibboDataType.WORD;
    //             if (VARTYPE === 'DOUBLE') {
    //                 varType = TibboDataType.FLOAT;
    //             }
    //             break;
    //         case 'IREG': // input register
    //             varName = 'modbus_callback_ReadInputRegister';
    //             varType = TibboDataType.WORD;
    //             if (VARTYPE === 'DOUBLE') {
    //                 varType = TibboDataType.FLOAT;
    //             }
    //             break;
    //         default:

    //             break;
    //     }
    //     for (let i = 0; i < OUTPUTS.length; i++) {
    //         const output = OUTPUTS[i];
    //         output.params[0].name = varName;
    //         output.params[0].dataType = varType;
    //     }

    //     return [];
    // }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const ID = this.getSettingValue('REGISTER');
        const register = project.getFeature(ID);
        if (!register) {
            return blocks;
        }
        const NAME = register.getSettingValue('NAME');
        const functionName = `${NAME}_data_available`;

        const DATATYPE = register.getSettingValue('DATATYPE');
        const links = project.getNodeLinks(this, 'modbus_value');
        let code = '';

        for (let i = 0; i < links.length; i += 1) {
            const link = links[i];
            let location = '';
            switch (DATATYPE) {
                case 'COIL': // coil
                    location = `${NAME}_COIL_WRITE`;
                    code = 'dim data as string=str(value)';
                    break;
                // case 'INPUT': // discrete contact/ cinput
                //     location = `${NAME}_INPUT_READ`;
                //     break;
                case 'HREG': // holding register
                    location = `${NAME}_HREG_WRITE`;
                    break;
                // case 'IREG': // input register
                //     location = `${NAME}_IREG_READ`;
                //     break;
                default:

                    break;
            }

            blocks.push({
                location,
                blockType: BlockType.CODE,
                id: this.getID(),
                template: `
    ${code}
    '****${link.getSourceId()}****'`,
            });
        }

        return blocks;
    }
}
